export enum ErpSyncMode {
    AutoSync = 'auto-sync',
    Sync = 'sync',
    Summary = 'summary',
}
